import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import AnimatedSection from "../../components/AnimatedSection/AnimatedSection";
import { IMAGES } from "../../data/constants";
import "./About.css";

function About() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const VALUES = [
    {
      icon: "🔧",
      title: t("about_page.values.expertise.title"),
      desc: t("about_page.values.expertise.desc"),
      img: IMAGES.strip[0],
    },
    {
      icon: "✅",
      title: t("about_page.values.quality.title"),
      desc: t("about_page.values.quality.desc"),
      img: IMAGES.strip[2],
    },
    {
      icon: "🤝",
      title: t("about_page.values.reliability.title"),
      desc: t("about_page.values.reliability.desc"),
      img: IMAGES.warehouse,
    },
    {
      icon: "🌿",
      title: t("about_page.values.sustainability.title"),
      desc: t("about_page.values.sustainability.desc"),
      img: IMAGES.maintain,
    },
  ];

  return (
    <div className="about" style={{ paddingTop: 66 }}>
      {/* Hero */}
      <div className="page-hero about__hero">
        <img
          src={IMAGES.about1}
          alt="About SK Associate — concrete floor experts India"
          className="hero-bg"
        />
        <div className="hero-overlay" />
        <div className="hero-content container">
          <p className="section-label">{t("about_page.hero.label")}</p>
          <h1 className="about__hero-title">{t("about_page.hero.title")}</h1>
        </div>
      </div>

      {/* Story */}
      <section className="section" style={{ background: "var(--bg2)" }}>
        <div className="container grid-2">
          <AnimatedSection>
            <div className="about__img-wrap">
              <img
                src={IMAGES.warehouse}
                alt="SK Associate warehouse floor polishing project"
                className="about__img"
              />
              <div className="about__img-thumb">
                <img
                  src={IMAGES.about2}
                  alt="SK Associate concrete repair work"
                />
              </div>
            </div>
          </AnimatedSection>

          <AnimatedSection delay={0.2}>
            <p className="section-label">{t("about_page.story.label")}</p>

            <h2 className="section-title" style={{ marginBottom: 18 }}>
              {t("about_page.story.title")}
            </h2>

            <p className="about__body">{t("about_page.story.body1")}</p>

            <p className="about__body" style={{ marginBottom: 28 }}>
              {t("about_page.story.body2")}
            </p>

            <button
              className="btn-primary"
              onClick={() => navigate("/contact")}
            >
              {t("about_page.story.cta")}
            </button>
          </AnimatedSection>
        </div>
      </section>

      {/* Location band */}
      <div className="about__band">
        <img
          src={IMAGES.factory}
          alt="SK Associate — India industrial corridor"
        />
        <div className="about__band-overlay" />
        <div className="about__band-text">
          <h2 className="about__band-title">
            {t("about_page.band.title")}
          </h2>
          <p className="about__band-sub">
            {t("about_page.band.locations")}
          </p>
        </div>
      </div>

      {/* Vision & Mission */}
      <section className="section" style={{ background: "var(--bg)" }}>
        <div className="container about__vm-grid">
          <AnimatedSection>
            <div className="about__vision">
              <span className="about__vm-icon">👁</span>
              <h2 className="about__vm-title">
                {t("about_page.vision.title")}
              </h2>
              <p className="about__vm-text">
                {t("about_page.vision.text")}
              </p>
            </div>
          </AnimatedSection>

          <AnimatedSection delay={0.15}>
            <div className="about__mission">
              <span className="about__vm-icon">🎯</span>
              <h2 className="about__vm-title">
                {t("about_page.mission.title")}
              </h2>
              <p className="about__vm-text">
                {t("about_page.mission.text")}
              </p>
            </div>
          </AnimatedSection>
        </div>
      </section>

      {/* Core Values */}
      <section className="section" style={{ background: "var(--bg2)" }}>
        <div className="container">
          <AnimatedSection>
            <h2
              className="section-title"
              style={{ textAlign: "center", marginBottom: 48 }}
            >
              {t("about_page.values.title")}
            </h2>
          </AnimatedSection>

          <div className="grid-auto">
            {VALUES.map((v, i) => (
              <AnimatedSection key={v.title} delay={i * 0.1}>
                <div className="about__value-card">
                  <div className="about__value-img-wrap">
                    <img src={v.img} alt={v.title} />
                  </div>

                  <div className="about__value-body">
                    <span className="about__value-icon">{v.icon}</span>
                    <h3 className="about__value-title">{v.title}</h3>
                    <p className="about__value-desc">{v.desc}</p>
                  </div>
                </div>
              </AnimatedSection>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}

export default About;